export enum MobileMessageActions {
  GET_TOKEN = 'get_token',
  LOGOUT = 'logout',
  CHECK_PUSH_PERMISSIONS = 'check_push_permissions',
  DEBUG = 'debug',
  CLOSE_SSO = 'close_sso',
  GO_HOME = 'go_home',
}
